import React from 'react';
import { DeleteOutlineTwoToneIcon, ModeEditTwoToneIcon } from 'tuui';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';
import { CONVERSION_STATUS } from 'modules/tracking/config/constants';
import { EventHeader } from '../EventHeader/EventHeader';
import CodelessCollapsibleCard from './CodelessCollapsibleCard';
import { EventRule } from './EventRule';
import styles from './eventCard.module.scss';

export const EventCard = ({ event, onEdit, setFocusedConversionId, isEditDisabled, onDelete }) => {
    const handleMouseEnter = () => setFocusedConversionId(event.id);
    const handleMouseLeave = () => setFocusedConversionId(undefined);

    const showDeleteButton = event.status !== CONVERSION_STATUS.ARCHIVED;

    return (
        <div onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
            <CodelessCollapsibleCard
                id={event.id + ''}
                header={
                    <>
                        <EventHeader event={event} />
                        {!isEditDisabled && (
                            <div className={styles['right-icon']} onClick={onEdit}>
                                <ModeEditTwoToneIcon />
                            </div>
                        )}
                    </>
                }
                headerClassName={styles['header-container']}
                isInitiallyCollapsed
                containerClassName={styles['card-container']}
            >
                <EventRule event={event} />
                {showDeleteButton && (
                    <button
                        className={styles['delete-button']}
                        onClick={() => onDelete(event.id)}
                        aria-label="Delete conversion"
                    >
                        <DeleteOutlineTwoToneIcon color="error" />
                        <FormattedMessage id="codeless.conversion.delete.button" defaultMessage="Delete" />
                    </button>
                )}
            </CodelessCollapsibleCard>
        </div>
    );
};
